export enum ApiAction {
  REG = "REG",
  MODIFY = "MODIFY",
  DETAIL = "DETAIL",
}
export enum ApiMethod {
  GET = "GET",
  POST = "POST",
  PUT = "PUT",
  PATCH = "PATCH",
  DELETE = "DELETE",
  get = "get",
  post = "post",
  put = "put",
  patch = "patch",
  delete = "delete",
}

export enum ApiResultCode {
  API_RES_GET = "0001", // 조회 성공
  API_RES_CREATE = "0002", // 생성 성공
  API_RES_UPDATE = "0003", // 수정 성공
  API_RES_DELETE = "0004", // 삭제 성공
  API_RES_IMAGE = "0005", // 이미지 저장 성공
  API_RES_BATCH_SYNC = "00011", // 배치 연동 성공
  API_RES_LOGIN = "9001", // 로그인 성공
  API_RES_LOGOUT = "9002", // 로그아웃 성공
}
export enum ApiErrorCode {
  API_RES_SMTP_ERR = "0007", //메일전송 오류
  API_RES_AUTH_ERR = "4001", // 로그인 정보 조회 실패
  API_RES_AUTH_FORCE_ERR = "4002", // 중복 로그인으로 인한 세션 강제 종료
  API_RES_AUTH_BINDING_ERR = "4003", // UA/IP 바인딩 실패
  API_RES_AUTZ_ERR = "4004", // 요청에 권한 없음
  API_RES_AUTZ_ROUTE_ERR = "4005", // 라우트 이동 권한 없음
  API_RES_AUTZ_EMPTY = "4010", // 권한 미부여
  API_RES_EXAM_AUTH_FORCE_ERROR = "4013", // 시험 강제 종료
  API_RES_LOGIN_ERR1 = "7001", // 로그인 아이디 또는 패스워드 실패
  API_RES_LOGIN_ERR2 = "7002", // 로그인 아이디 미승인
  API_RES_LOGIN_ERR3 = "7003", // 로그인 아이디 비활성화
  API_RES_ERR = "2001", // BACEKEND CHEKED COMMON ERROR
  API_RES_ENCRYPT_ERR = "2002", // BACKEND CHECKED EXCEPTION (ENCRYPT)
  API_RES_DECRYPT_ERR = "2003", // BACKEND CHECKED EXCEPTION (DECRYPT)
  API_RES_VOD_UPLOAD_INTEGRITY = "2007", // 업로드 part 누락/순서 손상
  API_RES_VOD_INVALID_FILE = "2008",     // MP4 컨테이너 손상 (moov atom 미발견)
  API_RES_COMPLETE_HAS_ENROLL = "2013", // 수료과정 삭제 — 신청자(수강생)가 있어 삭제 불가
  API_RES_VAL_PARAM = "3003", // 파라미터 위반
}

export enum BtnType {
  SAVE = "SAVE",
  UPDATE = "UPDATE",
  RESET = "RESET",
  CANCEL = "CANCEL",
  CLOSE = "CLOSE",
  DELETE = "DELETE",
  USE_Y = "USE_Y",
  USE_N = "USE_N",
  PREV = "PREV",
  NEXT = "NEXT",
  LIST = "LIST",
  RETURN = "RETURN",
  APPROVE = "APPROVE",
}
export enum KeyMap {
  f2 = "f2",
  f3 = "f3",
  f4 = "f4",
}
export enum SearchType {
  text = "text",
  radio = "radio",
  checkbox = "checkbox",
  autocomplete = "autocomplete",
  date = "date",
  number = "number",
}
